import React from 'react';

// #region import componentes molecules
import EmptyContent from '../../molecules/EmptyContent';
// #endregion

import { ButtonLink, EmptyContentText } from './styles';

const EmptyContentContainer = ({ display, marginTop, onClick, loading }) => {
  return (
    <EmptyContent isLoading={loading} display={display} marginTop={marginTop}>
      <EmptyContentText>
        Nenhuma contratante cadastrada
        <span>
          Para adicionar, clique no botão{' '}
          <ButtonLink
            type="button"
            onClick={onClick}
            data-testid="link-add-contratante"
          >
            + parâmetros
          </ButtonLink>
        </span>
      </EmptyContentText>
    </EmptyContent>
  );
};

export default EmptyContentContainer;
